
<template>
  <div v-loading="loading" class="dsf-control ds-schedule ds-tjy-unite-schedule">
    <dsf-calendar-nav
      class="tjy-calendar-nav"
      ref="schedule"
      :is-design="isDesign"
      :url="url1"
      :holiday-url="holidayUrl"
      :is-show-holiday="isShowHoliday"
      :to-day="toDay"
      :is-switch="isSwitch"
      :data-loaded-fun="dataLoadedFun"
      :is-parameter="isParameter"
      :type="settingConfig.type"
      :weekend-height-light="weekendHeightLight"
      :festival-height-light="festivalHeightLight"
      :is-show-month="isShowMonth"
      @change="scheduleChange"
    >
      <template v-slot:list>
        <div class="ds-schedule-content">
          <div class="list-time">
            <p class="time">{{  listTime[0]  }}</p>
            <p class="day">{{  listTime[1]  }}</p>
          </div>

          <dsf-empty-data v-if="!loading && !realList.length" />
          <div
            v-for="(item, index) in realList"
            :key="index"
            class="dsfa-sc-schedule-list-item"
            :type="item.type"
            @click="handleClick(item)"
          >
            <span
              :class="{ ellipsis2: settingConfig.ellipsis, text: true }"
              :title="item.theme"
            >{{ item.theme || "" }}</span>
          </div>
        </div>
      </template>
    </dsf-calendar-nav>
  </div>
</template>

<script>
const oneDay = 86400000;

export default dsf.component({
  name: "DsfTjyUniteScheduleList",
  mixins: [$mixins.control],
  ctrlCaption: "我的日程",
  design: {
    isMask: false
  },
  props: {
    url: {
      type: String,
      default: null
    },
    classInfo: {
      type: [Object, String],
      default: null
    },
    isParameter: {
      type: Boolean,
      default: false
    },
    // 是否允许切换周
    isSwitch: {
      type: Boolean,
      default: false
    },
    // 时间
    toDay: {
      type: [String, Date],
      default() {
        return new Date();
      }
    },
    // 个性化配置
    settingConfig: {
      type: Object,
      default() {
        return {
          pageSize: 2,
          type: "week",
          ellipsis: true
        };
      }
    },
    /**
     * 默认时间显示哪一天
     *   0: 有事件的那天
     *   1: 默认今天
     *   2: 默认周一
     */
    defaultActiveMode: {
      type: String,
      default: "0"
    },
    // 周末高亮
    weekendHeightLight: {
      type: Boolean,
      default: true
    },
    // 节日高亮
    festivalHeightLight: {
      type: Boolean,
      default: false
    },
    // 假日接口
    holidayUrl: {
      type: String,
      default: ""
    },
    // 是否显示假日
    isShowHoliday: {
      type: Boolean,
      default: false
    },
    // 是否显示日程类型
    isShowAgendaType: {
      type: Boolean,
      default: false
    },
    // 是否显示日程地址
    isShowAddress: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      // 请求次数
      postNum: 0,
      loading: false,
      list: [],
      url2: "",
      showAdd: false,
      isShowMonth: true, // 默认显示 7行日期 42天
      listTime: []
    };
  },
  computed: {
    realList() {
      return this.list.slice(0, this.settingConfig.pageSize);
    },
    classIdParam() {
      return this.classInfo ? "?classId=" + this.classInfo.id : "";
    },
    url1() {
      if (!this.url || this.url == "") {
        return null;
      }
      let categoryValue = dsf.url.parse(this.url);
      return (
        "/agenda/info/queryUserAgendaNumByDate" + (categoryValue.search ? categoryValue.search : "")
      );
    }
  },
  created() {
    if (this.isDesign) {
      for (var i = 0; i < 10; i++) {
        this.list.push({
          theme: "20200118jinhy排课测试课程",
          startTime: "24日14:30",
          endTime: "24日17:00",
          addressText: "金皓宇-知新101"
        });
      }
    }
  },
  mounted() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", "100%");
    }
  },
  methods: {
    handleClick(item) {
      let url = "service/agenda/edit?type=0&id=" + item.id;
      this.$open({
        title: "我的日程",
        state: 3,
        with: "1000px",
        height: "78vh",
        url: url + (item.isOwn == "1" ? "" : "&isview=1"),
        closed: () => {
          this.reloadData();
        },
        btns: []
      });
    },
    addSchedule() {
      // debugger;
      // let stringUrl = dsf.url.analyzing(this.url2).query;
      const stringUrl = dsf.url.parse(this.url2).searchQuery;
      let title = ["我的日程", "领导日程"];
      this.$open({
        title: title[stringUrl?.categoryValue || 0],
        state: 3,
        with: "1000px",
        height: "78vh",
        url:
          "service/agenda/edit?type=" +
          stringUrl?.categoryValue +
          "&startDate=" +
          stringUrl?.startDate,
        closed: () => {
          this.reloadData();
        },
        btns: []
      });
    },
    reloadData() {
      this.postData();
    },
    dataLoadedFun(data, vm) {
      if (this.defaultActiveMode == 2) {
        let { date } = vm.active;
        let w = date.getDay();
        w = !w ? 6 : w - 1;
        let newD = dsf.date.format(new Date(date.getTime() - w * oneDay), "yyyy-mm-dd");
        vm.active = _.find(vm.range, (r) => r.id == newD);
        return;
      }
      if (this.defaultActiveMode == 1) {
        return;
      }
      let days = [];
      _.forEach(data, (n, d) => {
        if (n > 0) {
          days.push(d?.slice(0, 10));
        }
      });
      if (days.length && days.indexOf(vm.active) === -1) {
        days.sort();
        vm.active = _.find(vm.range, (r) => r.id === days[0]);
      }
    },
    scheduleChange({ args: { id } }) {
      if (!this.url || this.url == "") {
        this.url2 = null;
      } else {
        // 获取url上没有配置参数
        let queryString = dsf.url.parse(this.url).search; // ? "?" : "&";
        // let queryString = dsf.url.analyzing(this.url).queryString == "" ? "?" : "&";
        queryString = !queryString ? "?" : "&";
        let params = "startDate=" + id + "&endDate=" + id + this.classIdParam;
        this.url2 = this.url + queryString + params;
      }
      this.listTime[0] = dsf.date.format(id,'yyyy-mm-dd DD')
      this.listTime[1] = dsf.date.format(id,'d') 
      this.postData();
    },
    postData() {
      if (this.isDesign) return;
      this.postNum++;
      if (!this.url2 || this.url2 == "") {
        this.list = [];
        return;
      }
      this.loading = true;
      this.$http
        .get(this.url2)
        .done(({ success, data, message }) => {
          if (success) {
            let list = Object.values(data);
            this.list = list.length ? list[0] : [];
            // this.showAdd = dsf.url.analyzing(this.url2).query?.startDate >= dsf.date.format(new Date(), 'yyyy-mm-dd')
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAgendaTypeStyle(item) {
      let { agendaTypeVo } = item;
      if (agendaTypeVo?.colorValue) {
        return {
          backgroundColor: agendaTypeVo.colorValue + "10",
          color: agendaTypeVo.colorValue
        };
      }
    },
  }
});
</script>